import { Box } from '@mui/material';
import React from 'react';
import ListaUsuarios from './ListaUsuarios';
import ListaUsuariosAsignados from './ListaUsuariosAsignados';

function Section4({ dataUser }) {
  return (
    <Box>
      <ListaUsuariosAsignados hostUser={dataUser} />
      <ListaUsuarios hostUser={dataUser} />
    </Box>
  );
}

export default Section4;
